// import React from 'react';
// import policyData from '../policy.json';

// const PolicyPage = () => {
//   return (
//     <div className="policy-container">
//       <h1>Privacy Policy</h1>
//       <div dangerouslySetInnerHTML={{ __html: policyData.privacyPolicy }} />
//     </div>
//   );
// };

// export default PolicyPage;


import React from 'react';
import { Link } from 'react-router-dom'; // Если вы используете React Router
import policyData from '../policy.json';
import Footer from './Footer';

const TermsOfUse = () => {
  return (
    <>
    <div className="termofuse-container">
      <div className="back-button">
        <Link to="/" className="back-link">← Back to main page</Link>
      </div>
      <h1>Terms of Use</h1>
      <div dangerouslySetInnerHTML={{ __html: policyData.termofuse }} />
    </div>
    <Footer />
    </>
  );
};

export default TermsOfUse;
